
// src/components/Layout/Layout.jsx
import React from 'react';
import { Header } from './Header';

export const Layout = ({ children }) => {
    return (
        <div className="min-h-screen bg-gray-100">
            <Header />
            <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                {children}
            </main>
        </div>
    );
};
